// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Gibraltar from '../_raw/flag/icon_flag_gibraltar.png';

export default () => <img src={Gibraltar} alt="Gibraltar" />;
